import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import FormView from '../../components/views/formView';
import { LayoutModuleProps } from './props';
import { Accordion } from '../../components/general/accordion';
import { Box } from '@mui/material';

export const LayoutModule = ({
    title,
    createPath,
    icon,
    iconTitle,
    titleChildren = 'FILTROS',
    titleRigthChildren,
    children,
    showTitle = true,
    additionalButtons,
    withAccordion = true,
}: LayoutModuleProps) => {
    const navigate = useNavigate();

    return (
        <>
            {showTitle && (
                <FormView
                    title={title}
                    onClickSave={
                        createPath ? () => navigate(createPath) : undefined
                    }
                    labelSave="Crear"
                    variantSave="outlined"
                    iconSave={
                        <AddIcon
                            sx={{ marginRight: { xs: -1, lg: undefined } }}
                        />
                    }
                    additionalButtons={additionalButtons}
                    iconTitle={iconTitle}
                />
            )}
            {withAccordion ? (
                <Accordion
                    title={titleChildren.toUpperCase()}
                    titleChildren={titleRigthChildren}
                    icon={icon}
                >
                    {children}
                </Accordion>
            ) : (
                <Box mt={'20px'}>{children}</Box>
            )}
        </>
    );
};
